import { render, staticRenderFns } from "./ProductOffers.vue?vue&type=template&id=40c52588"
import script from "./ProductOffers.vue?vue&type=script&lang=js"
export * from "./ProductOffers.vue?vue&type=script&lang=js"
import style0 from "./ProductOffers.vue?vue&type=style&index=0&id=40c52588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports